<template>
     <back-layout title="Perguntas Frequentes">
        <template #header>
            <div class="flex justify-between px-4 flex-col sm:flex-row">
                <h2 class="font-semibold text-2xl lg:text-4xl text-gray-300 leading-tight mb-4 md:mb-0">Perguntas Frequentes</h2>
                <Link :href="route('faqs.create')" class="border border-primary-900 text-primary-900 uppercase text-sm py-2 px-4 font-bold rounded-full flex items-center hover:bg-white hover:bg-opacity-50 transition"><icon name="plus-circle" class="w-5 h-5 mr-2" /> Criar Pergunta</Link>
            </div>
        </template>

        <!-- SEARCH BOX GOES HERE -->

        <div class="container mx-auto px-4">
            <div class="w-full">
                <div v-if="faqs.length">
                    <div class="px-4 my-2 flex items-center uppercase text-xs font-bold justify-between">
                        <p class="flex-1">Pergunta</p>
                        <p class="flex-1">Ações</p>
                    </div>
                    <div v-for="faq in faqs" class="bg-white overflow-hidden shadow rounded-lg p-4 my-2 flex items-center self-start space-x-2">
                        <Link :href="route('faqs.edit', faq.id)" class="flex-1 font-bold text-xs md:text-sm">{{ faq.question }}</Link>
                        <div class="flex-1 flex flex-row space-x-2">
                            <jet-button @click.prevent="editFaq(faq)" class="flex justify-center py-1 px-2 text-xs rounded-full border border-gray-400 bg-transparent hover:bg-gray-100 focus:bg-transparent active:bg-transparent active:border-gray-400 focus:border-gray-400 focus:ring-transparent active:shadow-0 focus:shadow-0 text-gray-400 mr-2"><icon name="edit" class="w-3 h-3" /> Editar</jet-button>

                            <jet-button @click.prevent="removeFaq(faq)" class="flex justify-center py-1 px-2 text-xs rounded-full border border-amber-600 bg-transparent hover:bg-gray-100 focus:bg-transparent active:bg-transparent active:border-amber-600 focus:border-amber-600 focus:ring-transparent active:shadow-0 focus:shadow-0 text-amber-600 mr-2"><icon name="trash" class="w-3 h-3" /> Remover</jet-button>
                        </div>
                    </div>
                </div>
                <div v-else class="text-center pt-20">
                    <em class="text-gray-400">Sem Perguntas</em>
                </div>
            </div>
        </div>
    </back-layout>
</template>


<script>
    import { defineComponent } from 'vue'
    import BackLayout from '@/Layouts/BackLayout.vue'
    import { Head, Link } from '@inertiajs/inertia-vue3'
    import JetButton from '@/Jetstream/Button.vue'
    import Icon from '@/Jetstream/Icon'

    export default defineComponent({
        components: {
            Head,
            Link,
            BackLayout,
            JetButton,
            Icon,
        },
        props: {
            canLogin: Boolean,
            canRegister: Boolean,
            laravelVersion: String,
            phpVersion: String,
            faqs: Array
        },
        data() {
            return {
            }
        },
        computed: {
        },
        methods: {
            dateFormated(faqDate) {
                let date = new Date(faqDate)
                return date.toLocaleDateString()
            },
            editFaq(faq) {
                this.$inertia.get(route('faqs.edit', faq));
            },
            removeFaq(faq) {
                if(confirm('Tem certeza? Esta ação é irreversível.')){
                    this.$inertia.delete(route('faqs.destroy', faq));
                }
            }
        },
    })
</script>